/*eslint-disable*/
import * as util from 'lib/utility';
import _ from 'lodash';
import { fetch } from 'lib/network/webapi';
import handleAppEvent from 'lib/event_engine';


export const MANAGE_FETCH_DATA = 'MANAGE_FETCH_DATA';
export const MANAGE_FETCH_DATA_SUCCESS = 'MANAGE_FETCH_DATA_SUCCESS';
export const MANAGE_FETCH_DATA_FAIL = 'MANAGE_FETCH_DATA_FAIL';
export const MANAGE_FETCH_LICENSE_SUCCESS = 'MANAGE_FETCH_LICENSE_SUCCESS';
export const MANAGE_FETCH_LICENSE = 'MANAGE_FETCH_LICENSE';
export const MANAGE_FETCH_LICENSE_FAIL = 'MANAGE_FETCH_LICENSE_FAIL';
export const ACTIVE_INDEX = 'ACTIVE_INDEX';
export const FILTER_EXPAND = 'FILTER_EXPAND';
export const SHOW_POPUP = 'SHOW_POPUP';
export const HIDE_POPUP = 'HIDE_POPUP';
export const SET_FILTER_VALUE = 'SET_FILTER_VALUE';
export const SET_FILTER_VALUE_SUCCESS = 'SET_FILTER_VALUE_SUCCESS';
export const SET_FILTER_VALUE_FAIL = 'SET_FILTER_VALUE_FAIL';
export const APPLY_FILTER = 'APPLY_FILTER';
export const CLEAR_ALL = 'CLEAR_ALL';
export const APPLY_SEARCH_NAME = 'APPLY_SEARCH_NAME';
export const MANAGE_FETCH_POLICY_DATA = 'MANAGE_FETCH_POLICY_DATA';
export const MANAGE_FETCH_POLICY_DATA_SUCCESS = 'MANAGE_FETCH_POLICY_DATA_SUCCESS';
export const MANAGE_FETCH_POLICY_DATA_FAIL = 'MANAGE_FETCH_POLICY_DATA_FAIL';
export const MANAGE_FETCH_CAMPAIGN = 'MANAGE_FETCH_CAMPAIGN';
export const MANAGE_FETCH_CAMPAIGN_SUCCESS = 'MANAGE_FETCH_CAMPAIGN_SUCCESS';
export const MANAGE_FETCH_CAMPAIGN_FAIL = 'MANAGE_FETCH_CAMPAIGN_FAIL';
export const DELETE_PERSONAL_LEAD_DATA = 'DELETE_PERSONAL_LEAD_DATA';
export const DELETE_PERSONAL_LEAD_DATA_SUCCESS = 'DELETE_PERSONAL_LEAD_DATA_SUCCESS';
export const DELETE_PERSONAL_LEAD_DATA_FAIL = 'DELETE_PERSONAL_LEAD_DATA_FAIL';
export const APPLY_SEARCH_ADDRESS = 'APPLY_SEARCH_ADDRESS';
export const FETCH_FILTER_VALUE = 'FETCH_FILTER_VALUE';
export const FETCH_FILTER_VALUE_SUCCESS = 'FETCH_FILTER_VALUE_SUCCESS';
export const FETCH_FILTER_VALUE_FAIL = 'FETCH_FILTER_VALUE_FAIL';
export const APPLY_PERSIST_FILTER = 'APPLY_PERSIST_FILTER';
export const UPDATE_NAME_SEARCH = 'UPDATE_NAME_SEARCH';
export const UPDATE_STREET_ADDRESS_SEARCH = 'UPDATE_STREET_ADDRESS_SEARCH';
export const UPDATE_PHONE_SEARCH = 'UPDATE_PHONE_SEARCH';
export const UPDATE_LANG = 'UPDATE_LANG';
export const UPDATE_ROW_DATA = 'UPDATE_ROW_DATA';
export const APPLY_SEARCH_PHONE = 'APPLY_SEARCH_PHONE';
export const FETCH_OPEN_LEADS = 'FETCH_OPEN_LEADS';
export const FETCH_OPEN_LEADS_SUCCESS = 'FETCH_OPEN_LEADS_SUCCESS';
export const FETCH_OPEN_LEADS_FAIL = 'FETCH_OPEN_LEADS_FAIL';
export const UPDATE_SELECTED_SEARCH_VALUES = 'UPDATE_SELECTED_SEARCH_VALUES';
export const FETCH_OPEN_LEADS_SEARCHDATA = 'FETCH_OPEN_LEADS_SEARCHDATA';
export const FETCH_OPEN_LEADS_SEARCHDATA_SUCCESS = 'FETCH_OPEN_LEADS_SEARCHDATA_SUCCESS';
export const FETCH_OPEN_LEADS_SEARCHDATA_FAIL = 'FETCH_OPEN_LEADS_SEARCHDATA_FAIL';
export const UPDATE_FILTER_VALUE = 'UPDATE_FILTER_VALUE';
export const UPDATE_FILTER_VALUE_SUCCESS = 'UPDATE_FILTER_VALUE_SUCCESS';
export const UPDATE_FILTER_VALUE_FAIL = 'UPDATE_FILTER_VALUE_FAIL';
export const SHOW_LOADING_SCREEN = 'SHOW_LOADING_SCREEN';

const initialState = {
  isLoading: false,
  currentLanguage: 'en',
  leadsManageData: [],
  tabOneLeadsData: [],
  tabTwoLeadsData: [],
  tabOneSearchData: [],
  tabTwoSearchData: [],
  tabActiveLeadsData: [],
  tabActiveSearchData: [],
  leadsManageError: '',
  activeIndex: 0,
  filterExpanded: false,
  primaryAndSecondaryRecordMapping: {},
  popupVisible: '',
  picklistLeadType: {},
  picklistBillingMode: {},
  picklistDncIndicator: {},
  picklistReasonCode: {},
  picklistPhoneNumber: {},
  picklistLanguage: {},
  picklistLeadDispositionStatus: {},
  policyData: {},
  policyPicklistData: {},
  manageCampaignData: [],
  rowData: {},
  licensedStates: [],
  tabOneSearchedLeads: [],
  totalActiveLeadsData: [],
  filter: {
    0: {
      state: [], /* These filter names should be in sync with the datakey defined in utility */
      county: [],
      city: [],
      zip: [],
      language: [],
      leadType: [],
      disposition: [],
      tier: [],
      campaign: [],
      campaignPurpose: []
    },
    1: {
      state: [],
      county: [],
      city: [],
      zip: [],
      language: [],
      leadType: [],
      disposition: [],
      tier: [],
      campaign: [],
      campaignPurpose: []
    },
    2: {
      state: [],
      county: [],
      city: [],
      zip: [],
      language: [],
      leadType: [],
      disposition: [],
      tier: [],
      campaign: [],
      campaignPurpose: []
    }
  },
  searchValueNamePriorityTab: '',
  searchStreetAddressPriorityTab: '',
  searchPhonePriorityTab: '',
  searchValueNameTabOne: '',
  searchStreetAddressTabOne: '',
  searchValueNameTabTwo: '',
  searchStreetAddressTabTwo: '',
  searchPhone:'',
  searchPhoneTabTwo: ''
};

const mockPicklistData = {
  cicaCallTypeModel: [{
    label: 'B',
    value: 1
  }, {
    label: 'R',
    value: 2
  }],
  cicaDncIndicatorModel: [{
    label: 'F',
    value: 1
  }, {
    label: 'I',
    value: 2
  }],
  cicaLangIndicatorModel: [{
    label: 'E',
    value: 1
  }, {
    label: 'S',
    value: 2
  }],
  cicaLeadDispositionStatusModel: [{
    label: 'Unworked',
    value: 1
  }, {
    label: 'Attempted Contact',
    value: 2
  }, {
    label: 'Appointment Set',
    value: 3
  }, {
    label: 'Sale',
    value: 4
  }, {
    label: 'No Sale',
    value: 5
  }],
  cicaLeadTypeModel: [{
    label: 'Active',
    value: 1
  }, {
    label: 'Lapsed',
    value: 2
  }, {
    label: 'Business',
    value: 3
  }, {
    label: 'Neighbor',
    value: 4
  }, {
    label: 'Campaign',
    value: 5
  }, {
    label: 'Warm',
    value: 6
  }, {
    label: 'Personal',
    value: 7
  }],
  cicaPhonenumberTypeModel: [{
    label: 'Home',
    value: 1
  }, {
    label: 'Business',
    value: 2
  }, {
    label: 'Additional',
    value: 3
  }],
  cicaReasonCodeModel: [{
    label: 'Does not qualify',
    value: 1
  }, {
    label: 'Not interested',
    value: 2
  }, {
    label: 'Cannot Afford',
    value: 3
  }, {
    label: 'Bad Information',
    value: 4
  }, {
    label: 'Unable to Contact',
    value: 5
  }, {
    label: 'Deceased',
    value: 6
  }, {
    label: 'Other',
    value: 7
  }]
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case FETCH_FILTER_VALUE_SUCCESS:
      return {
        ...state,
        filter: Object.assign({}, state.filter, action.result)
      };
    case SET_FILTER_VALUE_SUCCESS :
      if (state.activeIndex === 0) {
        return {
          ...state,
          filter: {
            ...state.filter,
            0: Object.assign({}, state.filter[state.activeIndex], action.result)
          }
        };
      } else if (state.activeIndex === 1) {
        return {
          ...state,
          filter: {
            ...state.filter,
            1: Object.assign({}, state.filter[state.activeIndex], action.result)
          }
        };
      }
      return {
        ...state,
        filter: {
          ...state.filter,
          2: Object.assign({}, state.filter[state.activeIndex], action.result)
        }
      };
    case SET_FILTER_VALUE_FAIL :
      return {
        ...state,
        isLoading: false,
        error: action.error
      };
    case APPLY_FILTER : {
      const filters = Object.keys(state.filter[state.activeIndex]);
      let data = state.leadsManageData;
      // let tabActiveLeadsData = state.totalActiveLeadsData;
      if (state.activeIndex === 0) {
        data = data.filter(obj => (((obj.leadType === 'Personal' && obj.status !== '4' && obj.status !== '5')
        && !obj.isSecondary) || ((obj.leadType === 'Warm' || obj.leadType === 'Campaign') && !obj.isSecondary &&
        obj.status !== '4' && obj.status !== '5') || ((obj.leadType !== 'Warm' ||  obj.leadType !== 'Campaign') &&
        !obj.isSecondary && obj.status !== '4' && obj.status !== '5' && obj.status !== '1')));
        filters.forEach((item) => {
          if (state.filter[state.activeIndex][item].length > 0) {
            data = data.filter(
              (obj) => {
                if (item === 'campaign') {
                  const dataArray = state.filter[state.activeIndex][item]
                  .reduce((list, campaignNameArray) => {
                    if (_.isArray(obj[item]) && _.includes(obj[item], campaignNameArray)) {
                      list.push(obj[item]);
                    }
                    return list;
                  }, []);
                  return _.isArray(dataArray) && dataArray.length > 0 ? true : false;
                }
                if (item === 'campaignPurpose') {
                  const dataArray = state.filter[state.activeIndex][item]
                  .reduce((list, campaignNameArray) => {
                    if (_.isArray(obj[item]) && _.includes(obj[item], campaignNameArray)) {
                      list.push(obj[item]);
                    }
                    return list;
                  }, []);
                  return _.isArray(dataArray) && dataArray.length > 0 ? true : false;
                }
                return _.includes(state.filter[state.activeIndex][item], obj[item])
              }
            );
          }
        });
        return {
          ...state,
          tabActiveLeadsData: data,
          tabActiveSearchData: data
        };
      } else if (state.activeIndex === 1) {
        let openLeadsData = state.tabOneSearchedLeads;
        data = openLeadsData.filter(obj => ((obj.status !== '4' && obj.status !== '5') && !obj.isSecondary));
        filters.forEach((item) => {
          if (state.filter[state.activeIndex][item].length > 0) {
            data = data.filter(
              (obj) => {
                if (item === 'campaign') {
                  const dataArray = state.filter[state.activeIndex][item]
                  .reduce((list, campaignNameArray) => {
                    if (_.isArray(obj[item]) && _.includes(obj[item], campaignNameArray)) {
                      list.push(obj[item]);
                    }
                    return list;
                  }, []);

                  return _.isArray(dataArray) && dataArray.length > 0 ? true : false;
                }
                if (item === 'campaignPurpose') {
                  const dataArray = state.filter[state.activeIndex][item]
                  .reduce((list, campaignNameArray) => {
                    if (_.isArray(obj[item]) && _.includes(obj[item], campaignNameArray)) {
                      list.push(obj[item]);
                    }
                    return list;
                  }, []);
                  return _.isArray(dataArray) && dataArray.length > 0 ? true : false;
                }
                return _.includes(state.filter[state.activeIndex][item], obj[item])
              }
            );
          }
        });
        return {
          ...state,
          tabOneLeadsData: data,
          tabOneSearchData: data
        };
      }
      else if (state.activeIndex === 2) {
        data = data.filter(obj => ((obj.status === '4' || obj.status === '5') && !obj.isSecondary));
        filters.forEach((item) => {
          if (state.filter[state.activeIndex][item].length > 0) {
            data = data.filter(
              (obj) => {
                if (item === 'campaign') {
                  const dataArray = state.filter[state.activeIndex][item]
                  .reduce((list, campaignNameArray) => {
                    if (_.isArray(obj[item]) && _.includes(obj[item], campaignNameArray)) {
                      list.push(obj[item]);
                    }
                    return list;
                  }, []);

                  return _.isArray(dataArray) && dataArray.length > 0 ? true : false;
                }
                if (item === 'campaignPurpose') {
                  const dataArray = state.filter[state.activeIndex][item]
                  .reduce((list, campaignNameArray) => {
                    if (_.isArray(obj[item]) && _.includes(obj[item], campaignNameArray)) {
                      list.push(obj[item]);
                    }
                    return list;
                  }, []);
                  return _.isArray(dataArray) && dataArray.length > 0 ? true : false;
                }
                return _.includes(state.filter[state.activeIndex][item], obj[item])
              }
            );
          }
        });
        return {
          ...state,
          tabTwoLeadsData: data,
          tabTwoSearchData: data
        };
      }
    }

    case APPLY_PERSIST_FILTER : {
      const filtersOne = Object.keys(state.filter[0]);
      let tabActiveLeadsData = state.totalActiveLeadsData;
      console.log('tabActiveLeadsData==> ', tabActiveLeadsData);
      console.log('LeadManageList==> ', state.leadsManageData);
      console.log('filtersOne==> ', filtersOne);
      const data = state.leadsManageData;
      // let tabActiveLeadsData = data.filter(action.result.manageList.filter(obj => (((obj.leadType === 'Personal' && obj.status !== '4' && obj.status !== '5')
      // && !obj.isSecondary) || ((obj.leadType === 'Warm' || obj.leadType === 'Campaign') &&
      // !obj.isSecondary && obj.status !== '4' && obj.status !== '5') ||
      // ((obj.leadType !== 'Warm' ||  obj.leadType !== 'Campaign') && !obj.isSecondary &&
      // obj.status !== '4' && obj.status !== '5' && obj.status !== '1'))));
      filtersOne.forEach((item) => {
        console.log('item==> ', item);
        if (state.filter[0][item].length > 0) {
          if (state.filter[0][item][0].split(' ')[0].indexOf('Warm') !== -1) {
            state.filter[0][item][0] = state.filter[0][item][0].split(' ')[0];
          }
          tabActiveLeadsData = tabActiveLeadsData.filter(
            (obj) => {
              if (item === 'campaign') {
                const dataArray = state.filter[0][item]
                .reduce((list, campaignNameArray) => {
                  if (_.isArray(obj[item]) && _.includes(obj[item], campaignNameArray)) {
                    list.push(obj[item]);
                  }
                  return list;
                }, []);

                return _.isArray(dataArray) && dataArray.length > 0 ? true : false;
              }
              if (item === 'campaignPurpose') {
                const dataArray = state.filter[state.activeIndex][item]
                .reduce((list, campaignNameArray) => {
                  if (_.isArray(obj[item]) && _.includes(obj[item], campaignNameArray)) {
                    list.push(obj[item]);
                  }
                  return list;
                }, []);
                return _.isArray(dataArray) && dataArray.length > 0 ? true : false;
              }
              return _.includes(state.filter[0][item], obj[item])
            }
          );
        }
      });
      const openLeads = Object.keys(state.filter[1]);
      let openLeadsTabData = state.tabOneSearchedLeads;
      let openLeadsTab = openLeadsTabData.filter(obj => ((obj.status !== '4' && obj.status !== '5') && !obj.isSecondary));
      openLeads.forEach((item) => {
        if (state.filter[1][item].length > 0) {
          openLeadsTab = openLeadsTab.filter(
            (obj) => {
              if (item === 'campaign') {
                const dataArray = state.filter[1][item]
                .reduce((list, campaignNameArray) => {
                  if (_.isArray(obj[item]) && _.includes(obj[item], campaignNameArray)) {
                    list.push(obj[item]);
                  }
                  return list;
                }, []);

                return _.isArray(dataArray) && dataArray.length > 0 ? true : false;
              }
              if (item === 'campaignPurpose') {
                const dataArray = state.filter[state.activeIndex][item]
                .reduce((list, campaignNameArray) => {
                  if (_.isArray(obj[item]) && _.includes(obj[item], campaignNameArray)) {
                    list.push(obj[item]);
                  }
                  return list;
                }, []);
                return _.isArray(dataArray) && dataArray.length > 0 ? true : false;
              }
              return _.includes(state.filter[1][item], obj[item])
            }
          );
        }
      });

      const filtersTwo = Object.keys(state.filter[2]);
      let tabtwodata = data.filter(obj => ((obj.status === '4' || obj.status === '5') && !obj.isSecondary));
      filtersTwo.forEach((item) => {
        if (state.filter[2][item].length > 0) {
          tabtwodata = tabtwodata.filter(
            (obj) => {
              if (item === 'campaign') {
                const dataArray = state.filter[1][item]
                .reduce((list, campaignNameArray) => {
                  if (_.isArray(obj[item]) && _.includes(obj[item], campaignNameArray)) {
                    list.push(obj[item]);
                  }
                  return list;
                }, []);

                return _.isArray(dataArray) && dataArray.length > 0 ? true : false;
              }
              if (item === 'campaignPurpose') {
                const dataArray = state.filter[state.activeIndex][item]
                .reduce((list, campaignNameArray) => {
                  if (_.isArray(obj[item]) && _.includes(obj[item], campaignNameArray)) {
                    list.push(obj[item]);
                  }
                  return list;
                }, []);
                return _.isArray(dataArray) && dataArray.length > 0 ? true : false;
              }
              return _.includes(state.filter[2][item], obj[item])
            }
          );
        }
      });
      return {
        ...state,
        tabActiveLeadsData: tabActiveLeadsData,
        tabActiveLeadsData: tabActiveLeadsData,
        tabOneLeadsData: openLeadsTab,
        tabOneSearchData: openLeadsTab,
        tabTwoLeadsData: tabtwodata,
        tabTwoSearchData: tabtwodata
      };
    }
    case APPLY_SEARCH_NAME : {
      const data = action.payload;
      if (state.activeIndex === 0) {
        return {
          ...state,
          tabActiveLeadsData: data
        };
      } else if (state.activeIndex === 1) {
        return {
          ...state,
          tabOneLeadsData: data
        };
      }
      return {
        ...state,
        tabTwoLeadsData: data
      };
    }

    case CLEAR_ALL: {
      if (state.activeIndex === 0) {
        return {
          ...state,
          filter: {
            ...state.filter,
            0: action.payload[state.activeIndex]
          }
        };
      } else if (state.activeIndex === 1) {
        return {
          ...state,
          filter: {
            ...state.filter,
            1: action.payload[state.activeIndex]
          }
        };
      }
      return {
        ...state,
        filter: {
          ...state.filter,
          2: action.payload[state.activeIndex]
        }
      };
    }
    case FILTER_EXPAND :
      return {
        ...state,
        filterExpanded: action.payload
      };
    case MANAGE_FETCH_DATA :
      return {
        ...state,
        isLoading: true
      };
    case MANAGE_FETCH_DATA_SUCCESS : {
      console.log("manageList==>", action.result.manageList);
      if (__MANAGE__ && __CONFIG__.testManageApp) {
        const formattedData = util.formatDataForTableView({
          data: action.result.data.value,
          picklistdata: mockPicklistData,
          currentLanguage: action.result.currentLanguage
        });
        return {
          ...state,
          isLoading: false,
          currentLanguage: 'en',
          leadsManageData: formattedData.manageList, 
          picklistLeadType: formattedData.picklistdata.cicaLeadTypeModel,
          picklistDncIndicator: formattedData.picklistdata.cicaDncIndicatorModel,
          picklistBillingMode: action.result.picklistdata.cicaRopBillingModel,
          picklistReasonCode: formattedData.picklistdata.cicaReasonCodeModel,
          picklistPhoneNumber: formattedData.picklistdata.cicaPhonenumberTypeModel,
          picklistLanguage: formattedData.picklistdata.cicaLangIndicatorModel,
          primaryAndSecondaryRecordMapping: formattedData.primaryAndSecondaryRecordMapping,
          picklistLeadDispositionStatus: formattedData.picklistdata.cicaLeadDispositionStatusModel,
          tabActiveLeadsData: formattedData.manageList.filter(obj => obj.leadType === 'Personal'),
          tabActiveSearchData: formattedData.manageList.filter(obj => ((obj.leadType === 'Warm' || obj.leadType === 'Campaign') && !obj.isSecondary && obj.status !== '4' && obj.status !== '5' && obj.status !== '1')),
          tabOneLeadsData: state.tabOneSearchedLeads,
          tabOneSearchData: state.tabOneSearchedLeads,
          tabTwoLeadsData: formattedData.manageList.filter(obj => ((obj.status === '4' || obj.status === '5') && !obj.isSecondary)),
          tabTwoSearchData: formattedData.manageList.filter(obj => ((obj.status === '4' || obj.status === '5') && !obj.isSecondary))
        };
      }
      return {
        ...state,
        isLoading: false,
        leadsManageData: action.result.manageList,
        currentLanguage: action.result.currentLanguage,
        picklistLeadType: action.result.picklistdata.cicaLeadTypeModel,
        picklistDncIndicator: action.result.picklistdata.cicaDncIndicatorModel,
        picklistBillingMode: action.result.picklistdata.cicaRopBillingModel,
        picklistReasonCode: action.result.picklistdata.cicaReasonCodeModel,
        picklistPhoneNumber: action.result.picklistdata.cicaPhonenumberTypeModel,
        picklistLanguage: action.result.picklistdata.cicaLangIndicatorModel,
        primaryAndSecondaryRecordMapping: action.result.primaryAndSecondaryRecordMapping,
        picklistLeadDispositionStatus: action.result.picklistdata.cicaLeadDispositionStatusModel,
        tabActiveLeadsData: action.result.manageList.filter(obj => (((obj.leadType === 'Personal' && obj.status !== '4' && obj.status !== '5') && !obj.isSecondary) || ((obj.leadType === 'Warm' || obj.leadType === 'Campaign') && !obj.isSecondary && obj.status !== '4' && obj.status !== '5') || ((obj.leadType !== 'Warm' ||  obj.leadType !== 'Campaign') && !obj.isSecondary && obj.status !== '4' && obj.status !== '5' && obj.status !== '1'))),
        totalActiveLeadsData: action.result.manageList.filter(obj => (((obj.leadType === 'Personal' && obj.status !== '4' && obj.status !== '5') && !obj.isSecondary) || ((obj.leadType === 'Warm' || obj.leadType === 'Campaign') && !obj.isSecondary && obj.status !== '4' && obj.status !== '5') || ((obj.leadType !== 'Warm' ||  obj.leadType !== 'Campaign') && !obj.isSecondary && obj.status !== '4' && obj.status !== '5' && obj.status !== '1'))),
        tabActiveSearchData: action.result.manageList.filter(obj => (((obj.leadType === 'Personal' && obj.status !== '4' && obj.status !== '5') && !obj.isSecondary) || ((obj.leadType === 'Warm' || (obj.campaignLeadType !== null  && obj.campaignLeadType !== '')) && !obj.isSecondary && obj.status !== '4' && obj.status !== '5') || ((obj.leadType !== 'Warm' ||  obj.campaignLeadType === null  || obj.campaignLeadType === '') && !obj.isSecondary && obj.status !== '4' && obj.status !== '5' && obj.disposition !== 'Unworked'))),
        tabOneLeadsData: state.tabOneSearchedLeads,
        tabOneSearchData: state.tabOneSearchedLeads,
        tabTwoLeadsData: action.result.manageList.filter(obj => ((obj.status === '4' || obj.status === '5') && !obj.isSecondary)),
        tabTwoSearchData: action.result.manageList.filter(obj => ((obj.status === '4' || obj.status === '5') && !obj.isSecondary))
      };
    }
    case MANAGE_FETCH_DATA_FAIL :
      return {
        ...state,
        isLoading: false,
        leadsManageError: action.error
      };
    case MANAGE_FETCH_POLICY_DATA :
      return {
        ...state,
        policyData: {},
        policyPicklistData: {},
        isLoading: true
      };
    case MANAGE_FETCH_POLICY_DATA_SUCCESS :
      return {
        ...state,
        policyData: action.result.data,
        policyPicklistData: action.result.picklistdata.cicaPolicyInfoTypeModel,
        isLoading: false,
      };
    case MANAGE_FETCH_POLICY_DATA_FAIL :
      return {
        ...state,
        isLoading: false,
        leadsManageError: action.error
      };
    case FETCH_OPEN_LEADS :
      return {
        ...state,
        isLoadingData: true
      };
    case FETCH_OPEN_LEADS_SUCCESS : {
      return {
        ...state,
        tabOneSearchedLeads: action.result.manageList.filter(obj => (((obj.status !== '4' && obj.status !== '5')) && !obj.isSecondary)),
        tabOneLeadsData: action.result.manageList.filter(obj => (((obj.status !== '4' && obj.status !== '5')) && !obj.isSecondary)),
        tabOneSearchData: action.result.manageList.filter(obj => (((obj.status !== '4' && obj.status !== '5')) && !obj.isSecondary)),
        isLoadingData: false,
      };
    }
    case FETCH_OPEN_LEADS_FAIL :
      return {
        ...state,
        isLoadingData: false,
        leadsManageError: action.error
      };  
      case FETCH_OPEN_LEADS_SEARCHDATA :
        return {
          ...state,
          isLoadingData: true
        };
      case FETCH_OPEN_LEADS_SEARCHDATA_SUCCESS : {
        return {
          ...state,
          tabOneSearchedLeads: action.result.manageList.filter(obj => (((obj.status !== '4' && obj.status !== '5')) && !obj.isSecondary)),
          tabOneLeadsData: action.result.manageList.filter(obj => (((obj.status !== '4' && obj.status !== '5')) && !obj.isSecondary)),
          tabOneSearchData: action.result.manageList.filter(obj => (((obj.status !== '4' && obj.status !== '5')) && !obj.isSecondary)),
          isLoadingData: false,
        };
      }
      case FETCH_OPEN_LEADS_SEARCHDATA_FAIL :
        return {
          ...state,
          isLoadingData: false,
          leadsManageError: action.error
        }; 
    case MANAGE_FETCH_LICENSE :
      return {
        ...state,
        isLoading: true
      };
    case MANAGE_FETCH_LICENSE_SUCCESS : {
      console.log('action.result==>', action.result);
      return {
        ...state,
        licensedStates: action.result
      };
    }
    case MANAGE_FETCH_LICENSE_FAIL :{
      console.log('action.errror==>', action.error);
      return {
        ...state,
        leadsManageError: action.error
      };
    } 
    case MANAGE_FETCH_CAMPAIGN: {}
      return {
        ...state,
        manageCampaignData: [],
        isLoading: false
      };
    case MANAGE_FETCH_CAMPAIGN_SUCCESS: {
      return {
        ...state,
        manageCampaignData: action.result,
        isLoading: false,
      };
    }
    case MANAGE_FETCH_CAMPAIGN_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.error
      };
    case DELETE_PERSONAL_LEAD_DATA:
      return {
        ...state,
        isLoading: true
      };
    case DELETE_PERSONAL_LEAD_DATA_SUCCESS :
      return {
        ...state,
        isLoading: false
      };
    case DELETE_PERSONAL_LEAD_DATA_FAIL :
      return {
        ...state,
        isLoading: false,
        error: action.error
      };
    case UPDATE_FILTER_VALUE:
      return {
        ...state,
        isLoading: true
      };
    case UPDATE_FILTER_VALUE_SUCCESS :
      return {
        ...state,
        isLoading: false
      };
    case UPDATE_FILTER_VALUE_FAIL :
      return {
        ...state,
        isLoading: false,
        error: action.error
      };  
    case ACTIVE_INDEX:
      return {
        ...state,
        activeIndex: action.payload
      };
    case SHOW_LOADING_SCREEN :
      return {
        ...state,
        isLoading: !state.isLoading
      };  
    case SHOW_POPUP:
      return {
        ...state,
        popupVisible: action.payload
      };
    case HIDE_POPUP:
      return {
        ...state,
        popupVisible: ''
      };
    case APPLY_SEARCH_ADDRESS : {
      const data = action.payload;
      if (state.activeIndex === 0) {
        return {
          ...state,
          tabActiveLeadsData: data
        };
      } else if (state.activeIndex === 1) {
        return {
          ...state,
          tabOneLeadsData: data
        };
      }
      return {
        ...state,
        tabTwoLeadsData: data
      };
    }
    case APPLY_SEARCH_PHONE : {
      const data = action.payload;
      if (state.activeIndex === 0) {
        return {
          ...state,
          tabActiveLeadsData: data
        };
      } else if (state.activeIndex === 1) {
        return {
          ...state,
          tabOneLeadsData: data
        };
      }
      return {
        ...state,
        tabTwoLeadsData: data
      };
    }
    case UPDATE_NAME_SEARCH:
      if (action.payload.tab === 0) {
        return {
          ...state,
          searchValueNamePriorityTab: action.payload.parameter
        }
      } else if (action.payload.tab === 1) {
        return {
          ...state,
          searchValueNameTabOne: action.payload.parameter
        }
      }
      return {
        ...state,
        searchValueNameTabTwo: action.payload.parameter
      }
    case UPDATE_STREET_ADDRESS_SEARCH:
      if (action.payload.tab === 0) {
        return {
          ...state,
          searchStreetAddressPriorityTab: action.payload.parameter
        }      
      } else if (action.payload.tab === 1) {
        return {
          ...state,
          searchStreetAddressTabOne: action.payload.parameter
        }      
      }
      return {
        ...state,
        searchStreetAddressTabTwo: action.payload.parameter
      }
    case UPDATE_PHONE_SEARCH:
      if (action.payload.tab === 0) {
        return {
          ...state,
          searchPhonePriorityTab: action.payload.parameter
        }
      } else if (action.payload.tab === 1) {
        return {
          ...state,
          searchPhone: action.payload.parameter
        }
      }
      return {
        ...state,
        searchPhoneTabTwo: action.payload.parameter
      }
    case UPDATE_LANG:
      return {
        ...state,
        currentLanguage: action.payload
      };
    case UPDATE_ROW_DATA:
      return {
        ...state,
        rowData: action.payload
      };
    case UPDATE_SELECTED_SEARCH_VALUES:
      return {
        ...state,
        searchStateValue: action.payload.searchState,
        searchCityValue: action.payload.searchCity,
        searchZipValue: action.payload.searchZip
      };
    default:
      return state;
  }
}

export const fetchData = () => {
  const request = __MANAGE__ && __CONFIG__.testManageApp ? fetch(`leads?$select=lastname,address1_stateorprovince,
    address1_telephone2,cica_dncafterdate,address2_city,address1_line1,
    address2_telephone1,cica_yrsmonthsph,cica_dob,cica_age,companyname,
    address1_county,address1_city,cica_pcname,cica_leadtype,
    address1_postalcode,cica_leaddispositionstatus,cica_langindicator,
    address1_telephone1,cica_calltype,_ownerid_value,cica_dncindicator,
    cica_householdkeycode,cica_campaign,cica_campaignseq,
    cica_campaignexpdate,cica_lastdispositiondate,cica_pcname,
    cica_personid,cica_occupation&$orderby=lastname asc&$top=100`) : util.fetchLeadData();

  return {
    types: [MANAGE_FETCH_DATA, MANAGE_FETCH_DATA_SUCCESS, MANAGE_FETCH_DATA_FAIL],
    promise: request
  };
};

export const fetchOpenLeadDataArray = () => {
  const request = util.fetchOpenLeadSearchData();
  return {
    types: [FETCH_OPEN_LEADS_SEARCHDATA, FETCH_OPEN_LEADS_SEARCHDATA_SUCCESS,
      FETCH_OPEN_LEADS_SEARCHDATA_FAIL],
    promise: request
  };
};

export const fetchManageCampaignData = () => {
  const request = util.fetchManageCampaignData();
  return {
    types: [MANAGE_FETCH_CAMPAIGN, MANAGE_FETCH_CAMPAIGN_SUCCESS,
      MANAGE_FETCH_CAMPAIGN_FAIL],
    promise: request
  };
};

export const fetchUserLicense = () => {
  const request = util.fetchUserLicense();
  return {
    types: [MANAGE_FETCH_LICENSE, MANAGE_FETCH_LICENSE_SUCCESS,
      MANAGE_FETCH_LICENSE_FAIL],
    promise: request
  };
};

export const fetchPolicyData = (id) => {
  const request = util.fetchPolicyData(id);
  return {
    types: [MANAGE_FETCH_POLICY_DATA, MANAGE_FETCH_POLICY_DATA_SUCCESS,
      MANAGE_FETCH_POLICY_DATA_FAIL],
    promise: request
  };
};

export const updateActiveIndex = index => (
  {
    type: ACTIVE_INDEX,
    payload: parseInt(index, 10)
  }
);

export const updateFilterExpanded = value => (
  {
    type: FILTER_EXPAND,
    payload: value
  }
);

export const showPopup = () => (
  {
    type: SHOW_POPUP,
    payload: '4'
  }
);
export const updateFilter = (key, value) => {
  const obj = {};
  const request = new Promise((resolve, reject) => {
    obj[key] = value ? value.map(item => {
      if (item.label.indexOf('Warm') > -1) {
        return item.label.split(" ")[0];
      }
      return item.label;
    }) : [];
    if (!_.isEmpty(obj)) {
      resolve(obj);
    } else {
      reject('Error Mapping the values');
    }
  });
  return {
    types: [SET_FILTER_VALUE, SET_FILTER_VALUE_SUCCESS, SET_FILTER_VALUE_FAIL],
    promise: request
  };
};

export const fetchFilterState = () => {
  const dataPayload = {
    dataBlobKey: 'persistedFilterState'
  };

  const request =  handleAppEvent('FETCH_MISC_DATA', dataPayload);
  return {
    types: [FETCH_FILTER_VALUE, FETCH_FILTER_VALUE_SUCCESS, FETCH_FILTER_VALUE_FAIL],
    promise: request
  };
};

export const updateFilterPersistState = (filterState) => {
  console.log('filterState==> ', filterState);
  const dataPayload = filterState;

  const request =  handleAppEvent('UPDATE_MISC', dataPayload);
  return {
    types: [UPDATE_FILTER_VALUE, UPDATE_FILTER_VALUE_SUCCESS, UPDATE_FILTER_VALUE_FAIL],
    promise: request
  };
};

export const hidePopup = () => (
  {
    type: HIDE_POPUP,
    payload: ''
  }
);

export const applyFilter = () => (
  {
    type: APPLY_FILTER,
    payload: ''
  }
);

export const applyPersistFilter = () => (
{
    type: APPLY_PERSIST_FILTER,
    payload: ''
  }
);

export const clearFilter = () => (
  {
    type: CLEAR_ALL,
    payload: initialState.filter
  }
);

export const applySearchName = sortedData => (
  {
    type: APPLY_SEARCH_NAME,
    payload: sortedData
  }
);

export const showLoadingScreen = () => {
  debug('CALLING LOADING SCREEN');
  return {
    type: 'SHOW_LOADING_SCREEN',
    payload: initialState.isLoading
  };
};

export const deletePersonalLeadData = (id) => {
  const request = util.deletePersonalLeadData(id);
  return {
    types: [DELETE_PERSONAL_LEAD_DATA, DELETE_PERSONAL_LEAD_DATA_SUCCESS,
      DELETE_PERSONAL_LEAD_DATA_FAIL],
    promise: request
  };
};

export const applySearchAddress = sortedData => (
  {
    type: APPLY_SEARCH_ADDRESS,
    payload: sortedData
  }
);

export const getOpenLeads = (stateSelected, citySelected, zipSelected) => {
  const request = util.fetchLeadData(stateSelected, citySelected,zipSelected);
  return {
    types: [FETCH_OPEN_LEADS,FETCH_OPEN_LEADS_SUCCESS,
      FETCH_OPEN_LEADS_FAIL],
    promise: request
  };
};

export const applySearchPhone = sortedData => (
  {
    type: APPLY_SEARCH_PHONE,
    payload: sortedData
  }
);

export const updateNameSearchParameter = (parameter, tab) => (
 {
    type: UPDATE_NAME_SEARCH,
    payload: {
      parameter,
      tab
    }
  }
);

export const updateStreetSearchParameter = (parameter, tab) => (
  {
    type: UPDATE_STREET_ADDRESS_SEARCH,
    payload: {
      parameter,
      tab
    }
  }
);

export const updatePhoneParameter = (parameter, tab) => (
  {
    type: UPDATE_PHONE_SEARCH,
    payload: {
      parameter,
      tab
    }
  }
);

export const updateSelectedLanguage = currentLanguage => (
  {
    type: UPDATE_LANG,
    payload: currentLanguage
  }
);

export const updateRowData = rowData => (
  {
    type: UPDATE_ROW_DATA,
    payload: rowData
  }
);

export const updateSelectedSearchValues = (searchState, searchCity, searchZip) => (
  {
    type: UPDATE_SELECTED_SEARCH_VALUES,
    payload: {
      searchState: searchState,
      searchCity: searchCity,
      searchZip: searchZip
    }
  }
);



// WEBPACK FOOTER //
// ./src/state/modules/manage.js